var indentation_default = {
  "indentZero": "E8vnw",
  "indentOne": "xG0c-",
  "indentTwo": "_97b53",
  "indentThree": "-T84C",
  "indentFour": "zN3tc",
  "indentFive": "tbhA7",
  "indentSix": "wB1kh"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
